<template>
  <QCard :class="['column', { 'full-width': $q.screen.lt.md }]">
    <QForm @submit="$emit('sendResetPassword')" class="q-py-lg q-px-xl">
      <PageHeader class="q-pb-md">
        <div class="col-12 q-mb-xs">
          <HeaderBackBtn @click="$emit('back', $event)" />
        </div>
        <h4 class="col-12">Reset Your Password</h4>
      </PageHeader>
      <SAIFormError v-if="!errors.$error && formError" class="q-mt-md q-mb-sm">
        {{ formError }}
      </SAIFormError>
      <SAIFormError
        v-if="errors.$error && passwordMatchError"
        class="q-mt-md q-mb-sm"
      />
      <SAIFormError
        v-if="errors.$error && !passwordMatchError"
        class="q-mt-md q-mb-sm"
      >
        The passwords do not match
      </SAIFormError>
      <div class="column">
        <SAIPasswordInput
          :value="password"
          class="q-mt-none"
          large
          :error="errors.password.$error"
          :show-password="showPassword"
          @input="$emit('update:password', $event)"
          @update:showPassword="$emit('update:showPassword', $event)"
        />
        <SAIPasswordInput
          :value="confirmationPassword"
          class="q-mt-sm"
          large
          :error="errors.confirmationPassword.$error"
          :show-password="showConfirmationPassword"
          @input="$emit('update:confirmationPassword', $event)"
          @update:showPassword="
            $emit('update:showConfirmationPassword', $event)
          "
        />
        <p class="q-px-sm q-mt-md text-center text-body3 text-grey-6">
          Password must include one symbol, one number and one upper case
        </p>
        <div class="row justify-center q-mt-lg">
          <SAIBtn
            padding="11px 48px"
            size="16px"
            label="Save New Password"
            :no-caps="true"
            :disable="disable"
            type="submit"
            :loading="loading"
          />
        </div>
      </div>
    </QForm>
    <QSpace />
    <SignUpCardAction @click="$emit('logIn')">
      <span>Back to Log in</span>
    </SignUpCardAction>
  </QCard>
</template>

<script>
import { SAIBtn, SAIPasswordInput, SAIFormError } from 'ecx.saigon.ui.common';
import { QForm, QCard, QSpace } from 'quasar';

export default {
  name: 'ResetPasswordConfirmation',
  props: {
    password: String,
    showPassword: Boolean,
    confirmationPassword: String,
    showConfirmationPassword: Boolean,
    passwordMatchError: Boolean,
    loading: Boolean,
    formError: String,
    disable: Boolean,
    errors: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    QCard,
    QForm,
    SAIBtn,
    SAIPasswordInput,
    SAIFormError,
    QSpace,
    SignUpCardAction: () => import('../../atom/sign-up-card-action'),
    HeaderBackBtn: () => import('../../atom/header-back-btn'),
    PageHeader: () => import('../../atom/page-header')
  }
};
</script>
